import { Section, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import {
  Point,
  MainText,
  RowWrapper,
  StyledStack,
  PointsWrapper,
  StyledInfoStack,
  StyledPointText,
  StyledTextStack,
  StyledContentStack,
} from './styles';
import { data } from './TechStack.data';

export const TechStack = ({ ...props }) => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text={'TechStack'} color="cyan" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">{data.mainText}</MainText>
            <StyledInfoStack>
              <PointsWrapper>
                {data.technologies.firstColumn.map((technology, index) => (
                  <RowWrapper key={`firstColumn-technology-${index}`}>
                    <Point />
                    <StyledPointText variant="regular_400">
                      {technology}
                    </StyledPointText>
                  </RowWrapper>
                ))}
              </PointsWrapper>
              <PointsWrapper>
                {data.technologies.secondColumn.map((technology, index) => (
                  <RowWrapper key={`secondColumn-technology-${index}`}>
                    <Point />
                    <StyledPointText variant="regular_400">
                      {technology}
                    </StyledPointText>
                  </RowWrapper>
                ))}
              </PointsWrapper>
              <PointsWrapper>
                {data.technologies.thirdColumn.map((technology, index) => (
                  <RowWrapper key={`thirdColumn-technology-${index}`}>
                    <Point />
                    <StyledPointText variant="regular_400">
                      {technology}
                    </StyledPointText>
                  </RowWrapper>
                ))}
              </PointsWrapper>
            </StyledInfoStack>
          </StyledTextStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
